/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { DegreePlan_LearnerAdmissionStatus as LearnerAdmissionStatus } from '__generated__/graphql-types';

import { breakpoints } from '@coursera/cds-core';

import TipNeedMoreFlexibility from 'bundles/degree-home/components/v3-dpm/components/HelpTips/TipNeedMoreFlexibility';
import TipReadyForFullDegree from 'bundles/degree-home/components/v3-dpm/components/HelpTips/TipReadyForFullDegree';
import TipReadyForYourNextDegreeCourse from 'bundles/degree-home/components/v3-dpm/components/HelpTips/TipReadyForYourNextDegreeCourse';
import TipReadyToEarnMoreCredit from 'bundles/degree-home/components/v3-dpm/components/HelpTips/TipReadyToEarnMoreCredit';
import useCurriculum from 'bundles/degree-home/components/v3-dpm/lib/useCurriculum';

const styles = {
  helpTipsWrapper: () => css`
    display: flex;
    gap: var(--cds-spacing-400);
    margin-bottom: var(--cds-spacing-400);
    flex-wrap: wrap;
    overflow: hidden; /* Allows child border-radius */
    ${breakpoints.down('xs')} {
      gap: var(--cds-spacing-200);
    }
  `,
};

export const HelpTipsWrapper = ({ children }: React.PropsWithChildren) => {
  return <div css={styles.helpTipsWrapper}>{children}</div>;
};

export const HelpTips = ({ learnerAdmissionStatus }: { learnerAdmissionStatus: LearnerAdmissionStatus }) => (
  <HelpTipsWrapper>
    <TipReadyToEarnMoreCredit learnerAdmissionStatus={learnerAdmissionStatus} />
    <TipReadyForFullDegree learnerAdmissionStatus={learnerAdmissionStatus} />
    <TipReadyForYourNextDegreeCourse learnerAdmissionStatus={learnerAdmissionStatus} />
    <TipNeedMoreFlexibility />
  </HelpTipsWrapper>
);

const HelpTipsEntrypoint = () => {
  const { data } = useCurriculum();

  const learnerAdmissionStatus = data?.Degree?.queryById?.curriculum?.learnerAdmissionStatus;

  if (!learnerAdmissionStatus) {
    return null;
  }

  return <HelpTips learnerAdmissionStatus={learnerAdmissionStatus} />;
};

export default HelpTipsEntrypoint;
